import instance from '@/utils/axios';

/**
 * gw系列设备历史检测数据
 * @param {*} data
 * @param {*} data.deviceTypeCode  设备类型编码
 * @returns
 */
export function gwDeviceDataList(data) {
  return instance({
    method: 'POST',
    url: '/gwData/getLastData',
    data
  });
}
/**
 * 获取gw设备检测记录数据
 * @param {*} data
 * @returns
 */
export function gwDeviceCheckData(data) {
  return instance({
    method: 'POST',
    url: '/gwData/getDetectDataList',
    data
  });
}
